import api from "@/config/api";

const path = "public/formular/employee/trainingproof"

export default {

  get: (token) => {
    return api.get(`${path}/${token}`)
  },
  post: (trainingproof, token) => {
    return api.post(path, trainingproof, { params: { token } })
  }
}
